import apiClient from './apiClient';

export interface ProjectListItem {
  id: string;
  name: string;
  projectCode: string;
  status: string;
  totalBudget?: number;
  projectManagerId?: string;
  startDate: string;
  plannedEndDate: string;
}

export interface ProjectMemberListItem {
  id: string;
  projectId: string;
  userId: string;
  joinedAt?: string;
  user?: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    role: string;
  };
}

export interface AddProjectMemberPayload {
  userId: string;
}

class ProjectService {
  async getProjects(): Promise<ProjectListItem[]> {
    const response = await apiClient.get('/projects');
    return response.data;
  }

  async getProjectMembers(projectId: string): Promise<ProjectMemberListItem[]> {
    const response = await apiClient.get(`/projects/${projectId}/members`);
    return response.data;
  }

  async addProjectMember(projectId: string, payload: AddProjectMemberPayload): Promise<ProjectMemberListItem> {
    const response = await apiClient.post(`/projects/${projectId}/members`, payload);
    return response.data;
  }

  async removeProjectMember(projectId: string, userId: string): Promise<void> {
    await apiClient.delete(`/projects/${projectId}/members/${userId}`);
  }
}

export default new ProjectService();
